export default __webpack_public_path__ + "static/media/circles-no-7.15cc6d35.ogg";